import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/web.dom-collections.iterator";
import environment from "web/script/modules/environment";
/**
 * Utility function to return the current language, including the locale.
 * I.e. 'en-gb' -> 'en-gb'
 */

export function getLanguage() {
  var language = environment.get("language", null);

  if (language === null) {
    return "en-us";
  }

  return language;
}
/**
 * Utility function to return the current language without the country.
 * I.e. 'en-gb' -> 'en'
 */

export function getLanguageWithoutCountry() {
  return getLanguage().split("-")[0];
}
/**
 * Utility function to determine if the application is in the English language.
 *
 * Always return true if force show English-only features is switched on
 */

export function languageIsEnglish() {
  if (environment.get("forceShowEnglishOnlyFeatures", false)) {
    return true;
  }

  var domainIsEnglish = environment.get("domainDefaultLanguageIsEnglish", true);
  var language = environment.get("language", null);
  return (language === null || language.startsWith("en")) && domainIsEnglish;
}
/**
 * DO NOT USE THIS FOR FEATURES THAT ARE NOT YET TRANSLATED!
 * Please use language_is_english() for this instead.
 * This is for features that are permanently only allowed in certain languages.
 * E.g. a PR project that's only translated into certain languages,
 * or the "impressum" section of legal docs that's only relevant to Germany.
 */

export function languageIs(allowedLanguage) {
  if (allowedLanguage.split("-").length !== 1) {
    // Including country in allowed language would effectively restrict the domain
    // not just the language, because the country in a language code is always
    // the SEO country for a domain. This method is not intended to restrict the domain.
    throw new Error("allowedLanguage arg cannot include country, so ".concat(allowedLanguage, " is invalid."));
  }

  return getLanguageWithoutCountry() === allowedLanguage;
}
/**
 * DO NOT USE THIS FOR FEATURES THAT ARE NOT YET TRANSLATED!
 * Please use language_is_english() for this instead.
 * This is for features that are permanently only allowed in certain languages.
 * E.g. a PR project that's only translated into certain languages,
 * or the "impressum" section of legal docs that's only relevant to Germany.
 */

export function languageIsIn(allowedLanguages) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = allowedLanguages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var allowedLanguage = _step.value;

      if (languageIs(allowedLanguage)) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
}